// RootRedirect - handles root route with SSO token detection
// Prevents redirect from removing token parameter before AuthContext can process it

import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const RootRedirect: React.FC = () => {
  const { loading } = useAuth();
  const [hasToken] = useState(() => {
    // CHECK if URL has token parameter
    const params = new URLSearchParams(window.location.search);
    return params.has('token');
  });

  // If there's a token in the URL, wait for AuthContext to process it
  if (hasToken && loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'var(--font-primary)',
        color: 'var(--color-text-primary)',
      }}>
        <p>Processing authentication...</p>
      </div>
    );
  }

  // Once loading is complete (or if no token), redirect to workspaces
  return <Navigate to="/workspaces" replace />;
};
